import React, { useTransition } from "react";
import s from "./Footer.module.scss";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className={s.footer}>
      <div className={s.footer_content}>
        <div className={s.logo}>
          <img src='/logo.png' className={s.logoImg} />
        </div>
        <div className={s.contacts}>
          {/* <div className={s.contacts_title}>Контакты</div> */}
          <div className={s.contacts_inner}>
            <div className={s.contacts_item}>
              {t("phone")}: +996 (500) 39-09-91
            </div>
            <div className={s.contacts_item}>
              {t("email")}: gsrelectrocar555@gmail.com
            </div>
          </div>
        </div>
      </div>
      <div className={s.bottom_footer}>{t("allRightsReserved")}</div>
    </div>
  );
};

export default Footer;
